goodCrumbsPosition()
scrollingFix()

let sliderContainer = $('.js_good-page__slider-container')
let nextEl = sliderContainer.find('.js_good-page__slider-next')
let prevEl = sliderContainer.find('.js_good-page__slider-prev')
let pagi = sliderContainer.find('.js_good-page__pagination')

let thumbs = new Swiper('.js_good-page__thumbs', {
    slidesPerView: 6,
    spaceBetween: 16,
    freeMode: true,
    watchSlidesProgress: true,
})
new Swiper('.js_good-page__slider', {
    slidesPerView: 1,
    navigation: {
        nextEl: nextEl[0],
        prevEl: prevEl[0],
    },
    loop: true,
    thumbs: {
        swiper: thumbs,
    },
    pagination: {
        el: pagi[0],
        type: 'bullets',
        bulletClass: 'slider__bullet',
        bulletActiveClass: 'slider__bullet_active',
        clickable: true,
    },
    modules: [SwiperModes.Navigation,SwiperModes.Pagination, SwiperModes.Thumbs]
})

lightGallery(sliderContainer[0], {
    selector: '.js_good-page__slider-item',
    licenseKey: 'your_license_key',
    speed: 500,
    download: false,
    plugins: [window.lgThumbnail],
})

lightGallery($('.good-page__pictures')[0], {
    selector: '.js_good-page__picture-item',
    licenseKey: 'your_license_key',
    speed: 500,
    download: false,
    plugins: [window.lgThumbnail]
})

$(window).on('scroll', function() {
    goodCrumbsPosition()
})

$(document).on('click', '.js_good-page__conditions-item', function() {
    let wrapper = $(this).closest('.js_good-page__conditions')
    let isActive = !$(this).hasClass('active')
    wrapper.find('.js_good-page__conditions-item').removeClass('active')
    wrapper.find('.js_good-page__conditions-block').removeClass('active')
    if (isActive) {
        $(this).addClass('active')
        wrapper.find(`.js_good-page__conditions-block[data-tab="${$(this).attr('data-tab')}"]`).addClass('active')
    }
})

$(document).on('click', '.js_good-page__nav-item', function() {
    let wrapper = $(this).closest('.js_good-page')
    let tab = $(this).attr('data-block')
    if (!$(this).hasClass('active')) {
        wrapper.find('.js_good-page__nav-item, .js_good-page__nav-scroll').removeClass('active')
        $(this).addClass('active')
        if (tab == 'all' || $(this).attr('data-block') == 'desk' || $(this).attr('data-block') == 'chars') {
            $('.js_good-page__main').addClass('active')
            wrapper.find('.js_good-page__full-item').removeClass('active')
            wrapper.find('.js_good-page__full-item[data-block="all"]').addClass('active')
            document.getElementById(tab).scrollIntoView()
        } else {
            $('.js_good-page__main').removeClass('active')
            wrapper.find('.js_good-page__full-item').removeClass('active')
            wrapper.find(`.js_good-page__full-item[data-block="${tab}"]`).addClass('active')
            document.getElementById(tab).scrollIntoView()
        }
    } else {
        document.getElementById(tab).scrollIntoView()
    }
})

$(window).on('scroll', function() {
    scrollingFix()
})

function goodCrumbsPosition() {
    if ($(window).scrollTop() > 70) {
        $('.js_good-page__crumbs').addClass('hide')
    } else {
        $('.js_good-page__crumbs').removeClass('hide')
    }
}

function scrollingFix() {
    if ($('.js_header').hasClass('header_scroll')) {
        $('html').css('scroll-padding-top', 130)
    } else {
        $('html').css('scroll-padding-top', 200)
    }
}